{
  "adultShort": "{n} adt",
  "childShort": "{n} chd",
  "infantShort": "{n} inf",
  "youthShort": "{n} yth"
}
